import type { Control } from "react-hook-form";
import { Controller } from "react-hook-form";

import type { BaseItem } from "@/core/types";
import { MultiSelect2 } from "@/components/UI2/molecules/MultiSelect";
import { TextField2 } from "@/components/UI2/molecules/TextField";

import type { BasicInfoFormValues } from "../schema";

type IntakeCoordinatorsMultiSelectProps = {
  control: Control<BasicInfoFormValues>;
  isReadOnly?: boolean;
  options: BaseItem[];
};

export function IntakeCoordinatorsMultiSelect({
  control,
  isReadOnly = false,
  options,
}: IntakeCoordinatorsMultiSelectProps) {
  return (
    <Controller
      control={control}
      name="intake_practice_ids"
      render={({ field, fieldState }) => {
        if (isReadOnly) {
          const selectedNames = (field.value ?? [])
            .map((id: string) => options.find((o) => o.id === id)?.name)
            .join(", ");

          return (
            <TextField2
              hasStrongLabel
              isReadOnly
              label="Intake Coordinator For Practice(s)"
              mode="input"
              onChange={field.onChange}
              value={selectedNames}
            />
          );
        }

        return (
          <MultiSelect2
            errorMessage={fieldState.error?.message}
            hasStrongLabel
            isInvalid={!!fieldState.error}
            label="Intake Coordinator For Practice(s)"
            onChange={(keys) => field.onChange(keys.map(String))}
            options={options}
            value={field.value ?? []}
          />
        );
      }}
    />
  );
}
